<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-blue-400 hover:text-blue-600" :href="route('category')">Categoria</inertia-link>
      <span class="text-blue-400 font-medium">/</span>
      {{ form.name }}
    </h1>
          <!-- <inertia-link class="text-blue-400 hover:text-blue-600" :href="route('category')">Cancelar Cambios</inertia-link> -->

    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre" />
          <text-input v-model="form.en_name" :error="form.errors.en_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre en ingles" />
          <text-area-input v-model="form.description" :error="form.errors.description" class="pr-6 pb-8 w-full lg:w-1/2" label="Descripcion" />
          <text-area-input v-model="form.en_description" :error="form.errors.en_description" class="pr-6 pb-8 w-full lg:w-1/2" label="Descripcion en ingles" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!category.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Categoria</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Actualizar Categoria</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextAreaInput from '@/Shared/TextAreaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    Icon,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    TextAreaInput
  },
  layout: Layout,
  props: {
    category: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.category.name,
        en_name: this.category.en_name,
        description: this.category.description,
        en_description: this.category.en_description,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('category.update', this.category.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this organization?')) {
        this.$inertia.delete(this.route('category.destroy', this.category.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this organization?')) {
        this.$inertia.put(this.route('category.restore', this.organization.id))
         this.form.post(this.route('category.store'))
      }
    },
  },
}
</script>
